import React, {Component} from 'react';
import {Icon, Segment, List, Progress} from 'semantic-ui-react';

export default class Goals extends Component {

    render() {

        const goals = [
            {
                "id": "0",
                "goal": "Retirement",
                "target": 1000000,
                "current": 453345
            },
            {
                "id": "1",
                "goal": "Vacation",
                "target": 5000,
                "current": 3800
            }
        ];

        return (
            <Segment.Group className='hooli-segment'>
                <Segment className='hooli-segment-top'>
                    <List>
                        <List.Item>
                            <List.Content floated='right'>
                                <a><Icon name='add' className='hooli-btn-segment' /> Set a Goal</a>
                            </List.Content>
                            <List.Header><h3 className='hooli-text-dark-blue'>GOALS</h3></List.Header>
                        </List.Item>
                    </List>
                </Segment>
                {goals.map(goal => (
                    <Segment key={goal.id}>
                        <List>
                            <List.Item>
                                <List.Content floated='right'>
                                    <div className='hooli-text-grey hooli-text-light'>
                                        ${goal.current.toLocaleString(navigator.language, { minimumFractionDigits: 0 })
                                        + " out of $" + goal.target.toLocaleString(navigator.language, { minimumFractionDigits: 0 })}
                                        </div>
                                </List.Content>
                                <List.Header>{goal.goal}</List.Header>
                                <Progress color='blue' percent={goal.current / goal.target * 100} className='hooli-list-spacing-m'/>
                            </List.Item>
                        </List>
                    </Segment>
                ))}
                <Segment className='hooli-segment-bottom'/>
            </Segment.Group>
        )

    }

}
